import React from 'react';
import {ButtonLink} from '@homeaway/react-buttons';

const IsListed = ({
    titleOwner,
    titleManager,
    btnNo,
    btnYes,
    onBackClick,
    onListedClick,
    backText,
    userType,
}) => {
    return (
        <div className="contact__listed">
            {userType === 'frbo' && <h3>{titleOwner}</h3>}
            {userType === 'pm' && <h3>{titleManager}</h3>}
            <button className="btn btn-default" id="No" onClick={onListedClick}>
                {btnNo}
            </button>
            <button
                className="btn btn-default"
                id="Yes"
                onClick={onListedClick}
            >
                {btnYes}
            </button>
            <div className="contact__back-link">
                <ButtonLink label={backText} onClick={onBackClick} />
            </div>
        </div>
    );
};

export default IsListed;
